export default __webpack_public_path__ + "static/media/learose5-1024w.0de770d0.avif";